export default __webpack_public_path__ + "media/21dd9aaac2203ebed7bc557f392805a42613e17b373184ca234fafc427b1b11c.svg";